export default "__VITE_ASSET__e29b3886__"